import { dateToDatabaseDateString } from '../../../utils/dateUtils';
import { BAH_CHILD_DATAMEMBER, BAH_CHILD_RECORD_ID } from '../../constants/runtime.constants';

export const normalizeAttachmentDataForOffline = ({
  fileName,
  rowId,
  PARENT_PK_ID,
  formInfo,
  gridId,
  parentData,
}) => {
  const currentDate = dateToDatabaseDateString(Date.now());
  const attachmentObj = {
    BAH_ID: rowId,
    BAH_OWNER_ID: PARENT_PK_ID || 'NR_1',
    BAH_ORG_ID: formInfo.userContext?.f_CurrentOrgUnitID,
    BAH_CREATED_DATE: currentDate,
    BAH_CREATED_BY: formInfo.userContext?.f_ActorCode,
    BAH_MODIFIED_DATE: undefined,
    BAH_MODIFIED_BY: undefined,
    BAH_STEP_NAME: formInfo.stepName,
    BAH_STEP_ID: formInfo.stepId,
    BAH_WFE_ID: formInfo.workflowId,
    BAH_WORKFLOW_KEY: formInfo.workflowKey,
    BAH_DESCRIPTION: '',
    ACO_ID: undefined,
    ACO_ORG_ID: formInfo.userContext?.f_CurrentOrgUnitID,
    ACO_BAH_ID: rowId,
    ACO_FILE_NAME: fileName,
    ACO_CREATED_DATE: undefined,
    ACO_CREATED_BY: undefined,
    ACO_MODIFIED_DATE: undefined,
    IsNewObject: true,
    IsExistingObject: false,
    BAH_ACO_TEMP_ID: undefined,
    ContainerInstanceIdForHandMadeNewObject: gridId,
  };

  if (parentData) {
    attachmentObj[BAH_CHILD_RECORD_ID] = parentData.parentRowId;
    attachmentObj[BAH_CHILD_DATAMEMBER] = parentData.parentEntityName;
  }

  return attachmentObj;
};
